import type {
  SystemCalendarDraft,
  SystemCalendarReconciliation,
  SystemCalendarRemovalResult,
  SystemCalendarSyncResult,
} from './systemCalendarTypes';

// Web ve yeni takvim modülünü taşımayan eski ikililer için güvenli varsayılan.
// Mobil build Metro'da systemCalendar.native.ts dosyasını kullanır.
export const systemCalendarAvailable = false;

export async function ensureMeetupInSystemCalendar(
  _userId: number,
  _meetupId: number,
  _draft: SystemCalendarDraft
): Promise<SystemCalendarSyncResult> {
  return 'unavailable';
}

export async function restoreMeetupInSystemCalendar(
  _userId: number,
  _meetupId: number,
  _draft: SystemCalendarDraft
): Promise<SystemCalendarSyncResult> {
  return 'unavailable';
}

export async function restoreMeetupTimeInSystemCalendar(
  _userId: number,
  _meetupId: number,
  _draft: SystemCalendarDraft
): Promise<SystemCalendarSyncResult> {
  return 'unavailable';
}

export async function readMeetupSystemCalendarReconciliation(
  _userId: number,
  _meetupId: number
): Promise<SystemCalendarReconciliation | null> {
  return null;
}

export async function removeMeetupFromSystemCalendar(
  _userId: number,
  _meetupId: number
): Promise<SystemCalendarRemovalResult> {
  return 'unavailable';
}

export async function waitForSystemCalendarOperations(_userId: number): Promise<void> {}
